export default __webpack_public_path__ + "static/media/detail_small_1_3.70bc6907.png";